var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconCheckGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.59l.78-.803c1.3.348 3.542 1.154 5.553 2.398C8.45 6.4 12.721 2.919 15.304 1.333L16 2.05 6.667 14.667 0 7.59z",
    fill: "#7ECB1C"
  })));
}

export default SvgIconCheckGreen;